import React, { useEffect } from 'react';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { defineMessages, useIntl } from 'react-intl';
import { Grid } from 'semantic-ui-react';

const messages = defineMessages({
  invisibleCaptcha: {
    id: 'HCaptchaInvisibleInfo',
    defaultMessage:
      'This site is protected by hCaptcha and its ' +
      '<a href="https://www.hcaptcha.com/privacy">Privacy Policy</a> and ' +
      '<a href="https://www.hcaptcha.com/terms">Terms of Service</a> apply.',
  },
  captchaResponse: {
    id: 'HCaptchaResponse',
    defaultMessage: 'hCaptcha response token',
  },
});

const HCaptchaWidget = ({
  captchaRef,
  captchaToken,
  sitekey,
  size,
  HCaptcha: hcaptchalib,
}) => {
  const HCaptchaComponent = hcaptchalib.default;
  const intl = useIntl();

  const onVerify = (token) => {
    captchaToken.current = token;
  };

  const onExpire = () => {
    captchaToken.current = null;
  };

  const onLoad = () => {
    captchaRef.current.execute();
  };

  // FIXME: https://github.com/hCaptcha/react-hcaptcha/issues/332
  useEffect(() => {
    // Adiciona aria-label aos textareas gerados pelo hCaptcha para acessibilidade
    const addAriaLabels = () => {
      const gRecaptchaTextarea = document.querySelector(
        'textarea[name="g-recaptcha-response"]',
      );
      const hCaptchaTextarea = document.querySelector(
        'textarea[name="h-captcha-response"]',
      );

      const ariaLabel = intl.formatMessage(messages.captchaResponse);

      if (
        gRecaptchaTextarea &&
        !gRecaptchaTextarea.getAttribute('aria-label')
      ) {
        gRecaptchaTextarea.setAttribute('aria-label', ariaLabel);
      }
      if (hCaptchaTextarea && !hCaptchaTextarea.getAttribute('aria-label')) {
        hCaptchaTextarea.setAttribute('aria-label', ariaLabel);
      }
    };

    // Executa imediatamente e também após um pequeno delay para garantir que o DOM foi atualizado
    addAriaLabels();
    const timer = setTimeout(addAriaLabels, 200);

    return () => clearTimeout(timer);
  }, [intl]);

  // TODO: language
  if (size === 'invisible')
    return (
      <Grid.Row centered className="row-padded-top">
        <Grid.Column textAlign="center">
          <HCaptchaComponent
            ref={captchaRef}
            sitekey={sitekey}
            onLoad={onLoad}
            onVerify={onVerify}
            onExpire={onExpire}
            size={size}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: intl.formatMessage(messages.invisibleCaptcha),
            }}
          />
        </Grid.Column>
      </Grid.Row>
    );
  else
    return (
      <Grid.Row centered className="row-padded-top">
        <Grid.Column textAlign="center">
          <HCaptchaComponent
            ref={captchaRef}
            sitekey={sitekey}
            onLoad={onLoad}
            onVerify={onVerify}
            size={size}
          />
        </Grid.Column>
      </Grid.Row>
    );
};

export default injectLazyLibs(['HCaptcha'])(HCaptchaWidget);
